import { useMemo } from 'react';
import { useAuth } from '../auth/AuthContext';
import type { Authed } from '../api/gymApi';

/**
 * Bundles the two auth callbacks every API call needs into one stable object,
 * so effects that depend on it don't re-run on every render.
 */
export function useAuthed(): Authed {
  const { getToken, refresh } = useAuth();
  return useMemo(() => ({ getToken, refresh }), [getToken, refresh]);
}
